SharedAjaxErrorView = require('../../../../shared/frontend/views/ajax_error_view')
SupportVerticalCurrentOrderView = require('../order_related/vertical_current_order_view')
SupportVerticalSelectDifferentOrderMenuView = require('../order_related/vertical_select_different_order_menu_view')
SupportV2StepOneView = require('./v2_view')

class SupportVerticalStepOneView extends SupportV2StepOneView
  className: 'v2 step-one vertical'

  initialize: ->
    SupportV2StepOneView::initialize.apply(this, arguments)
    @errorView = new SharedAjaxErrorView()

  render: (params) ->
    SupportV2StepOneView::render.call(this, params)

  loadOrderErrorCallback: () ->
    @errorView.render(
      container: @$el
      errorHtmlText: I18n.t("js.modules.support.order_listing_error")
    )
    @styleErrorView()

  loadOrderDetailsErrorCallback: () ->
    @renderOrderListing()
    $errorMessage = $("<div></div>")
    @errorView.render(
      container: $errorMessage
      errorHtmlText: I18n.t("js.modules.support.order_details_error")
    )
    $(".help-wizard-content", @$el).prepend($errorMessage)
    @styleErrorView()

  noOrdersView: () ->
    @errorView.render(
      container: @$el
      errorHtmlText: I18n.t("js.modules.support.no_order_message")
    )
    @styleErrorView()

  styleErrorView: () ->
    $(".page-error", @$el).removeClass("text-center").addClass("notification")

  renderProgressBar: (contentWrapper)->

  createSubViews: () ->
    @selectDifferentOrderMenu = new SupportVerticalSelectDifferentOrderMenuView()
    @currentOrderView = new SupportVerticalCurrentOrderView()

  handleNormalAndMyGrouponsFlow: (order)->
    @renderOrderDetails()

module.exports = SupportVerticalStepOneView
